/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, func, string, shape, arrayOf, number,
} from 'prop-types';
import SelectOccasions from './SelectOccasions';
import ModalViewNav from './ModalViewNav';

const styles = (theme) => ({
    occasionWrapper: {
        padding: '10px 30px',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
        },
    },
    tabGroups: {
        display: 'flex',
        padding: 15,
        [theme.breakpoints.down('xs')]: {
            display: 'block',
            padding: 5,

        },
    },
});

const CelebrationCardView = ({
    classes, modalViews, selectedView, change, occasionData, selectedOccasion, setModalView, selectedCard, messageData, dataDictionary,
}) => (
    <Grid
        item
        xs={12}
        className={classes.tabGroups}
        style={{ justifyContent: selectedView === modalViews.SELECT_TEMPLATE ?  'space-between' : 'space-around' }}
    >
        {selectedView === modalViews.SELECT_TEMPLATE
            && (
                <Grid item xs={4} className={classes.occasionWrapper}>
                    <SelectOccasions
                        occasionData={occasionData}
                        selectedOccasion={selectedOccasion}
                        change={change}
                    />
                </Grid>
            )}

        {/* Navigation bar to that lets user select the View on the screen */}
        <Grid item xs={8} className={classes.occasionWrapper}>
            <ModalViewNav
                setModalView={setModalView}
                modalViews={modalViews}
                selectedView={selectedView}
                selectedCard={selectedCard}
                messageData={messageData}
                dataDictionary={dataDictionary}
            />
        </Grid>
    </Grid>
);
CelebrationCardView.propTypes = {
    classes: object.isRequired,
    modalViews: shape({
        PERSONALIZE: string,
        REVIEW: string,
    }).isRequired,
    selectedView: string.isRequired,
    change: func.isRequired,
    occasionData: arrayOf(
        shape({
            rank: number.isRequired,
            refrence: arrayOf(
                shape({
                    uid: string.isRequired,
                }),
            ).isRequired,
        }),
    ).isRequired,
    selectedOccasion: string.isRequired,
    setModalView: func.isRequired,
    selectedCard: shape({
        title: string,
    }).isRequired,
    messageData: shape({
        text: string,
    }).isRequired,
    dataDictionary: object,
};
CelebrationCardView.defaultProps = {
    dataDictionary: {},
};
export default withStyles(styles)(CelebrationCardView);
